import { flatten, uniq } from 'lodash'

export const chunkArray = (array, chunkSize) => {
  if (Array.isArray(array)) {
    let results = []
    let orginalArray = [ ...array ]
    while (orginalArray.length > 0) {
      results.push(orginalArray.splice(0, chunkSize))
    }
    return results
  } else {
    throw new Error('Non-array type was provided.')
  }
}

export const flattenArray = (multiDimensionalArray) => (
  // flattens one level deep
  [].concat(...multiDimensionalArray)
)

export const getTotal = (amounts) => (
  amounts.reduce((a, b) => a + b, 0)
)

export const getUniqueValuesInArrayOfArrays = (arrayOfArrays) => (
  uniq(flatten(arrayOfArrays))
)

export const getUniqueValuesInArrayOfObjectsByProperty = (arrayOfObjects, property) => (
  property
    ? [...new Set(arrayOfObjects.map(object => object[property]))]
    : null
)

export const createArrayWithSequence = (length, startValue = 1) => {
  if (length !== undefined) {
    return Array.from({ length }, (_, index) => startValue + index)
  } else {
    throw new Error('No length parameter provided.')
  }
}

export const getArrayDuplicates = (array) => {
  // returns duplicates in an array with integer/string elements
  let duplicates = array.filter((e,i,a) => a.indexOf(e) !== i)
  return duplicates
}



// WEBPACK FOOTER //
// ./src/utils/array/index.js